/* eslint-disable no-restricted-imports  */

import { Component, Inject, OnInit } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ShellTrackHandlers } from '@cigna/cigna-for-brokers/shared/analytics-util';
import { TrainingEducationService } from '../+state';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AppstateFacade } from '@cigna/cigna-for-brokers/shell/data-access';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { getAdobeSiteSection } from '@cigna/cigna-for-brokers/shared/util';
import { Router } from '@angular/router';
import {
  AppStateGateway,
  GatewayConfig,
  GATEWAY_CONFIG,
} from '@cigna/cigna-for-brokers/shared/gateways';
import { get } from 'lodash';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'cigna-continuing-education',
  templateUrl: './continuing-education.component.html',
  styleUrls: ['./continuing-education.component.scss'],
})
export class ContinuingEducationComponent implements OnInit {
  profileData$ = this._appstateFacade.isProfileUser$;
  isImpersonatorFlag: boolean;
  operatorId: unknown;
  envName: string;
  isNewKaplanUrlEnabledFlag: boolean;
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private _service: TrainingEducationService,
    private analytics: ShellTrackHandlers,
    private _gw: AppStateGateway,
    private router: Router,
    private _appstateFacade: AppstateFacade,
    private featureTogglesFacade: FeatureTogglesFacade,
    private translate: TranslateService,
    @Inject(GATEWAY_CONFIG) private _config: GatewayConfig,
  ) {}

  ngOnInit(): void {
    this.profileData$.pipe(takeUntil(this._ngUnsubscribe$)).subscribe((res) => {
      if (res) {
        this.operatorId = res.accessTokenBody['agent.operatorId'];
        if (this.operatorId && this.operatorId !== '') {
          this.isImpersonatorFlag = true;
        }
      }
    });

    this.envName = this._config.environmentName;
    const featureFlagBase = this.translate.instant(`featureFlag`);

    const flagObj = get(featureFlagBase, this.envName);
    this.isNewKaplanUrlEnabledFlag = get(flagObj, 'isNewKaplanUrlEnabled');
  }

  exploreCatalog() {
    if (this.isNewKaplanUrlEnabledFlag) {
      this._service.getContinuingEdExploreCatalogNew();
    } else {
      this._service.getContinuingEdExploreCatalog();
    }

    this.analytics.trackEventOther({}, 'Explore Catalog', 'ac25031', {
      eVar119: 'MTD-1864',
      eVar120: 'explore-catalog-button',
      prop67: 'action',
      channel: 'Learning Center',
      pageName: 'Producer Learning Center',
      prop20: 'continuing education',
      eVar160: this._gw.getContinuingEdExploreCatalog(),
    });
  }

  stepByStepLink() {
    const adobeSection = getAdobeSiteSection(this.router.url);
    this.analytics.trackEventOther({}, 'step-by-step-guide', 'ac25032', {
      eVar119: 'MTD-1666',
      eVar120: 'step-by-step-guide-link',
      prop67: 'action',
      channel: adobeSection.channel,
      pageName: adobeSection.pageName,
      prop20: 'continuing education',
      prop160:
        'https://www.brainshark.com/cignaproducer/vu?pi=zIfzfiWuKzbXcLz0',
    });

    window.open(
      'https://www.brainshark.com/cignaproducer/vu?pi=zIfzfiWuKzbXcLz0',
      '_blank',
    );
  }
}
